/** The person's current local time, or null when their zone is unset or unknown. */
export function localTimeIn(timezone: string | null | undefined, now: Date = new Date()): string | null {
  if (!timezone) return null;
  try {
    return new Intl.DateTimeFormat(undefined, { hour: "numeric", minute: "2-digit", timeZone: timezone, timeZoneName: "short" }).format(now);
  } catch {
    return null;
  }
}
